import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
    Paper,
    TableContainer
} from '@material-ui/core';
import { ProductsSummary } from './ShippingOrdersSummaryService';
import i18next from 'i18next';

interface Props {
    summary: ProductsSummary;
}

const TOP_PRODUCTS_LIMIT = 5;

export const ShippingOrdersSummaryView: React.FC<Props> = ({ summary }) => {
    return (
        <div
            className="print"
            style={{
                pageBreakBefore: 'always',
                padding: '20px'
            }}
        >
            <Typography variant="h5" gutterBottom>
                {i18next.t('shippingPlanning.productsSummary')}
            </Typography>

            <div style={{ marginBottom: '40px' }}>
                <Typography variant="h6" gutterBottom>
                    {i18next.t('shippingPlanning.highQuantityProducts')}
                </Typography>
                <TableContainer component={Paper}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>
                                    <strong>
                                        {i18next.t('shippingPlanning.sku')}
                                    </strong>
                                </TableCell>
                                <TableCell>
                                    <strong>
                                        {i18next.t('shippingPlanning.variant')}
                                    </strong>
                                </TableCell>
                                <TableCell>
                                    <strong>
                                        {i18next.t(
                                            'shippingPlanning.warehouse'
                                        )}
                                    </strong>
                                </TableCell>
                                <TableCell align="right">
                                    <strong>
                                        {i18next.t('shippingPlanning.quantity')}
                                    </strong>
                                </TableCell>
                                <TableCell align="right">
                                    <strong>
                                        {i18next.t('shippingPlanning.boxes')}
                                    </strong>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {summary.highQuantityProducts
                                .slice(0, TOP_PRODUCTS_LIMIT)
                                .map((item, index) => (
                                    <TableRow key={index}>
                                        <TableCell>
                                            {item.productCode}
                                        </TableCell>
                                        <TableCell>
                                            {item.variants.length > 0
                                                ? item.variants.join(', ')
                                                : '-'}
                                        </TableCell>
                                        <TableCell>
                                            {item.stockLocations.length > 0
                                                ? item.stockLocations.join(', ')
                                                : '-'}
                                        </TableCell>
                                        <TableCell align="right">
                                            {item.quantity}
                                        </TableCell>
                                        <TableCell align="right">
                                            {item.boxCount || '-'}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            {summary.highQuantityProducts.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={5} align="center">
                                        {i18next.t(
                                            'shippingPlanning.noProducts'
                                        )}
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>

            <div>
                <Typography variant="h6" gutterBottom>
                    {i18next.t('shippingPlanning.smallItems')}
                </Typography>
                <TableContainer component={Paper}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>
                                    <strong>
                                        {i18next.t('shippingPlanning.sku')}
                                    </strong>
                                </TableCell>
                                <TableCell>
                                    <strong>
                                        {i18next.t('shippingPlanning.variant')}
                                    </strong>
                                </TableCell>
                                <TableCell>
                                    <strong>
                                        {i18next.t(
                                            'shippingPlanning.warehouse'
                                        )}
                                    </strong>
                                </TableCell>
                                <TableCell align="right">
                                    <strong>
                                        {i18next.t('shippingPlanning.quantity')}
                                    </strong>
                                </TableCell>
                                <TableCell align="right">
                                    <strong>
                                        {i18next.t('shippingPlanning.boxes')}
                                    </strong>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {summary.smallItems.map((item, index) => (
                                <TableRow key={index}>
                                    <TableCell>{item.productCode}</TableCell>
                                    <TableCell>
                                        {item.variants.length > 0
                                            ? item.variants.join(', ')
                                            : '-'}
                                    </TableCell>
                                    <TableCell>
                                        {item.stockLocations.length > 0
                                            ? item.stockLocations.join(', ')
                                            : '-'}
                                    </TableCell>
                                    <TableCell align="right">
                                        {item.quantity}
                                    </TableCell>
                                    <TableCell align="right">
                                        {item.boxCount || '-'}
                                    </TableCell>
                                </TableRow>
                            ))}
                            {summary.smallItems.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={5} align="center">
                                        {i18next.t(
                                            'shippingPlanning.noProducts'
                                        )}
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div>
    );
};
